import { createApp } from 'vue'
import { createPinia } from "pinia";
import App from './App.vue'
import axios from 'axios'
import Panzoom from '@panzoom/panzoom'

const app = createApp(App);

app.config.globalProperties.axios = axios;
app.config.globalProperties.Panzoom = Panzoom;

app.use(createPinia());

app.mount('#app');
